import { useQuery } from "@apollo/client/react";
import { MyUserCenterDocument } from "@repo/graphql/documents/user/query.generated";

export const useMyUser = () => {
  const queryResult = useQuery(MyUserCenterDocument);
  const user = queryResult.data?.userResource.user;
  const userProfilePicture = user?.profilePicture;
  return {
    user,
    userProfilePicture,
    ...queryResult,
  };
};
